import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import mainActions from '../redux/modules/main';
import actions from '../redux/modules/user';
import appConfig from '../config/app-config';
import ModalDm from './Modal/ModalDm';

const { IMAGE_PATH } = appConfig;

class Header extends Component {
  state = {
    user: JSON.parse(localStorage.getItem('user')) || { nivel: {} }
  };

  componentDidMount = async () => {
    const { loadUser, loadCounters, loadStores } = this.props;
    await loadUser();
    await loadStores();
    loadCounters();
  };

  getPermission = async () => {
    const { user: userObj } = this.state;
    const permission = await userObj && userObj.nivel ? userObj.nivel.id : null;
    return permission
  };

  toggleNavigation = event => {
    document.body.classList.toggle('nav-actived');
    event.preventDefault();
  };

  openMdLojas = () => {
    const { toggleMyStores } = this.props;
    toggleMyStores();
  };

  render() {
    const { user } = this.state;
    const { showAdminMenu, totalPedidosPendentes, totalProdutosCarrinho, showMyStores, stores } = this.props;
    const permission = user && user.nivel ? user.nivel.id : null;
    const isDesigner = permission && permission !== 40;
    const isGerenteComercial = permission && permission !== 45;
    const userNameStyle = showAdminMenu ? { color: '#00c8ba' } : {};

    return (
      <div className="header-wrapper">
        <div className="overlay-menu" onClick={this.toggleNavigation} />
        <div className="header-bar">
          <div className="header-left">
            <a className="nav-toggle" onClick={this.toggleNavigation}>
              <i className="material-icons">menu</i>
              <img className="logo-header" src={require('../../src/assets/images/logo_dmjob.png')} alt="Logotipo Dm Job" />
            </a>
          </div>

          <div className="header-nav">
            {(!showAdminMenu && isDesigner && isGerenteComercial) && (
              <div>
                {/* <button type="button" className="modalLojas" onClick={() => this.openMdLojas()}>
                  <span>Suas Lojas</span>
                </button> */}
                <ModalDm
                  openModal={this.openMdLojas}
                  heading="Minhas Lojas"
                  hiddenModal={this.openMdLojas}
                  openMd={showMyStores}
                  modalWidth="modalWidth"
                >
                  <div>
                    <div className="bx--row">
                      {stores && (
                        stores.length > 0 ? (
                          stores.map(store => (
                            <p>{store.nome}</p>
                          ))
                        ) : (
                          <p>Sem lojas para exibir.</p>
                        ))}
                    </div>
                  </div>
                </ModalDm>
              </div>
            )}

            {(!showAdminMenu && isDesigner && isGerenteComercial) && (
              <Link to="/pedidos/agencia" className="header-nav-button">
                <i className="material-icons">assignment</i>
                <span>{totalPedidosPendentes}</span>
              </Link>
            )}

            {(!showAdminMenu && isDesigner && isGerenteComercial) && (
              <Link to="/carrinho" className="header-nav-button-cart">
                <i className="material-icons">shopping_cart</i>
                <span>{totalProdutosCarrinho}</span>
              </Link>
            )}

            <Link to="/perfil/informacoes" className="user">
              <div
                className="image"
                style={{ backgroundImage: user && user.foto ? `url(${IMAGE_PATH + user.foto})` : 'none' }}
              />

              <div className="user-data hide-sm">
                <p className="name" style={userNameStyle}>
                  {user.nome}
                </p>
                <p className="role">{user.nivel.nome}</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  totalPedidosPendentes: state.main.totalPedidosPendentes,
  totalProdutosCarrinho: state.main.totalProdutosCarrinho,
  showAdminMenu: state.main.showAdminMenu,
  showMyStores: state.main.showMyStores,
  stores: state.main.stores
});

const mapDispatchToProps = dispatch => ({
  loadUser() {
    dispatch(actions.receiveUserData());
  },
  loadCounters() {
    return dispatch(mainActions.receiveCounters());
  },
  toggleMyStores() {
    dispatch(mainActions.toggleMyStores());
  },
  loadStores() {
    return dispatch(mainActions.myStores());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js